import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const BASE_URL = environment.base_url_second;

@Injectable({
    providedIn: 'root'
})
export class CustomerFormService {
    public galleryImages = [
        { name: 'top_of_the_foot', path: 'assets/images/custom-form-gallery/top_of_the_foot.png' },
        { name: 'achilles_area', path: 'assets/images/custom-form-gallery/achilles_area.png' },
        { name: 'ankle', path: 'assets/images/custom-form-gallery/ankle.png' },
        { name: 'arch', path: 'assets/images/custom-form-gallery/arch.png' },
        { name: 'forefoot_area', path: 'assets/images/custom-form-gallery/forefoot_area.png' },
        { name: 'heel', path: 'assets/images/custom-form-gallery/heel.png' },
        { name: 'radiant_pain', path: 'assets/images/custom-form-gallery/radiant_pain.png' },
        { name: 'achilles_tendon', path: 'assets/images/custom-form-gallery/achilles_tendon.png' },
        { name: 'flat_feet', path: 'assets/images/custom-form-gallery/flat_feet.png' },
        { name: 'heel_pain', path: 'assets/images/custom-form-gallery/heel_pain.png' },
        { name: 'heel_spur', path: 'assets/images/custom-form-gallery/heel_spur.png' },
        { name: 'metatarsalgia', path: 'assets/images/custom-form-gallery/metatarsalgia.png' },
        { name: 'peatonal_tendinitis', path: 'assets/images/custom-form-gallery/peatonal_tendinitis.png' },
        { name: 'plantar_fascitis', path: 'assets/images/custom-form-gallery/plantar_fascitis.png' },
        { name: 'prontation', path: 'assets/images/custom-form-gallery/prontation.png' },
        { name: 'sesamoiditis', path: 'assets/images/custom-form-gallery/sesamoiditis.png' },
    ]

    constructor(private http: HttpClient,) { }

    getCustomForm(): any {
        const url = `${BASE_URL}/customForms`;

        return this.http.get(url).pipe(
            map((resp) => resp)
        )
    }

    deleteCustomForm(formId: string) {
        const url = `${BASE_URL}/customForm/${formId}`;
        return this.http.delete(url);
    }

    getFormById(formId: string) {
        const url = `${BASE_URL}/customForm/public/${formId}`;
        return this.http.get(url);
    }

    getCustomFormByClientId(clientId: string, userId: string) {
        const url = `${BASE_URL}/customForm/public/clientId/${clientId}?userId=${userId}`;
        return this.http.get(url);
    }

    addCustomForm(formJson: any) {
        const url = `${BASE_URL}/customForm`;
        return this.http.post(url, formJson);
    }

    updateCustomForm(formId: string, formJson: any) {
        const url = `${BASE_URL}/customForm/${formId}`;
        return this.http.put(url, formJson);
    }

    updateCustomFormName(formId: string, formJson: any) {
        const url = `${BASE_URL}/customForm/rename/${formId}`;
        return this.http.put(url, formJson);
    }

}
